module.exports = __webpack_public_path__ + "static/media/turbine.074bd832.gif";